export default __webpack_public_path__ + "abffb90d9366b17746ddd8bd800ef5fc.png";